module.exports = [{"name":"TAIT_TAIT225","version":1}]